export enum ObjectState {
	Open = 0,
	Closed = 1,
	Canceled = 2,
	Scheduled = 3,
}
